import { createContext, useContext } from 'react';
import type { UserContext } from '@zola-helpers/client/dist/es/@types';
import { PaperOnboardTypes } from './constants';

export type OpenPaperOnboardProps =
  | {
      paperOnboardCallback?: never;
      /** Paper onboard closes with openPaperOnboard({ paperOnboardType: undefined }); */
      paperOnboardType: undefined;
      projectType?: never;
      redirectHref?: never;
    }
  | {
      paperOnboardCallback?: () => void;
      /** Paper onboard opens with openPaperOnboard({ paperOnboardType: PaperOnboardTypes[TYPE], ... }); */
      paperOnboardType: PaperOnboardTypes;
      projectType: string;
      redirectHref?: string;
    };

export type PaperOnboardContextType = {
  /** Temp feature flag */
  isPushSignupIntoCustomization: boolean;
  /** Function responsible for opening appropriate paper onboard */
  openPaperOnboard: (props: OpenPaperOnboardProps) => void;
  /** Optional callback on successful onboard/login, such as toggling guest addressing or removing cart item */
  paperOnboardCallback?: () => void;
  /** Paper onboard type to open */
  paperOnboardType?: PaperOnboardTypes;
  /** Project type needed for tracking and opening subsequent paper onboard type */
  projectType?: string;
  /** Optional redirect href on successful onboard/login */
  redirectHref?: string;
  /** User context */
  userContext: UserContext;
};

const defaultPaperOnboardContext: PaperOnboardContextType = {
  isPushSignupIntoCustomization: false,
  openPaperOnboard: () => null,
  userContext: {},
};

export const PaperOnboardContext = createContext(defaultPaperOnboardContext);

export const usePaperOnboardContext = () => useContext(PaperOnboardContext);
